import { useEffect } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';

import { useIsCurrentPageLive } from '@confluence/live-pages-utils/entry-points/useIsCurrentPageLive.ts';
import { fg } from '@confluence/feature-gating';
import {
	useNetworkStatusListenerCache,
	ClientNetworkStatus,
} from '@confluence/legacy-schema-bridge/entry-points/useNetworkStatusListenerCache.ts';

export type useNativeCollabConnectionListenerProps = {
	collabEditConnectionTimedOut: boolean;
	collabInitTimedOut: boolean;
};

export const useNativeCollabConnectionListener = ({
	collabEditConnectionTimedOut,
	collabInitTimedOut,
}: useNativeCollabConnectionListenerProps): void => {
	const isLivePage = useIsCurrentPageLive();
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const networkStatus = useNetworkStatusListenerCache();

	useEffect(() => {
		if (!fg('confluence_analytics_on_ncs_disconnect')) {
			return;
		}

		const networkOffline =
			networkStatus === ClientNetworkStatus.IP_BLOCKED ||
			networkStatus === ClientNetworkStatus.OFFLINE;
		const isCollabDisconnected = collabEditConnectionTimedOut || collabInitTimedOut;

		if (!networkOffline && isCollabDisconnected) {
			// If NCS times out, but user is still connected to network
			createAnalyticsEvent({
				type: 'sendTrackEvent',
				data: {
					source: 'nativeCollabComponent',
					actionSubject: 'nativeCollabConnectionListener',
					actionSubjectId: 'nativeCollabConnectionListener',
					action: 'disconnected',
					attributes: {
						isLivePage,
					},
				},
			}).fire();
		}
	}, [
		networkStatus,
		collabEditConnectionTimedOut,
		isLivePage,
		collabInitTimedOut,
		createAnalyticsEvent,
	]);
};
